import {
  DropdownMenuOptionVariants,
  WorkflowNode,
} from "@validereinc/common-components";
import { Handle, NodeProps, Position } from "@xyflow/react";
import classNames from "classnames/bind";
import React, { useMemo } from "react";
import { useWorkflowGraphInteractions } from "../WorkflowGraphCanvas/useWorkflowGraphInteractions";
import { useWorkflowGraphState } from "../WorkflowGraphCanvas/WorkflowGraphStore";
import styles from "./ParallelGraphNode.module.scss";
import { WorkflowGraphParallelNodeType } from "./types";
import { DebugTooltip } from "../WorkflowGraphNode/DebugTooltip";

const cx = classNames.bind(styles);

const ParallelGroupNode = (props: NodeProps<WorkflowGraphParallelNodeType>) => {
  const { data, id, selected, dragging, positionAbsoluteX, positionAbsoluteY } =
    props;
  const { isInEditMode, currentConfiguration, setStepIdToDelete } =
    useWorkflowGraphState();
  const { onCopyStep } = useWorkflowGraphInteractions();

  const shouldShowDeleteAction = !(
    currentConfiguration?.start === id && data.step?.end
  );

  const actions = useMemo(
    () =>
      isInEditMode
        ? [
            {
              label: "Copy",
              onClick: () => onCopyStep(props.data.step),
            },
            ...(shouldShowDeleteAction
              ? [
                  {
                    label: "Delete",
                    variant: DropdownMenuOptionVariants.DANGER,
                    onClick: () => setStepIdToDelete(id),
                  },
                ]
              : []),
          ]
        : [],
    [
      isInEditMode,
      props.data.step,
      id,
      shouldShowDeleteAction,
      setStepIdToDelete,
      onCopyStep,
    ]
  );

  return (
    <div
      style={{
        opacity: data?.isTranslucent ? 0.3 : 1,
        transition: "opacity 0.2s ease-out",
      }}
    >
      <WorkflowNode
        {...data}
        actions={actions}
      />
      <Handle
        type="target"
        position={Position.Top}
        className={cx("handle", "target")}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="a"
        className={cx("handle", "source")}
      />
      <DebugTooltip
        id={id}
        positionAbsoluteX={positionAbsoluteX}
        positionAbsoluteY={positionAbsoluteY}
        selected={selected}
        dragging={dragging}
        variant={data.variant}
        isTranslucent={data.isTranslucent}
      />
    </div>
  );
};

export default ParallelGroupNode;
